module.exports = __webpack_public_path__ + "static/media/store.543aab3a.svg";